import DEFAULTS from './VirtualizedGridContainer.settings'
import type { GridBreakpoint } from './VirtualizedGridContainer.types'

const { DEFAULT_BREAKPOINTS } = DEFAULTS

export function colsForWidth(width: number, breakpoints: GridBreakpoint[] = DEFAULT_BREAKPOINTS) {
  const sorted = [...breakpoints].sort((a, b) => b.min - a.min)
  for (const b of sorted) {
    if (width >= b.min) return b.cols
  }
  return 1
}